import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
  startContent?: React.ReactNode;
  description?: string;
  fullWidth?: boolean;
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  startContent,
  description,
  fullWidth = true,
  ...props
}: SelectProps) {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-1167">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700" data-id="element-1168">
          {label} {props.required && <span className="text-red-500" data-id="element-1169">*</span>}
        </label>}
      <div className="relative" data-id="element-1170">
        {startContent && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-1171">
            {startContent}
          </div>}
        <select id={selectId} className={`
            block w-full rounded-xl border-2 border-slate-200 bg-slate-50/50 appearance-none
            ${startContent ? 'pl-10' : 'pl-4'} 
            pr-10 py-2.5 text-sm transition-all duration-200
            focus:border-seform-orange focus:bg-white focus:ring-0 focus:outline-none
            disabled:bg-slate-100 disabled:text-slate-500
            ${error ? 'border-red-300 focus:border-red-500' : 'hover:border-slate-300'}
            ${className}
          `} {...props} data-id="element-1172">
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-1173">
              {opt.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-slate-400" data-id="element-1174">
          <ChevronDown className="h-4 w-4" data-id="element-1175" />
        </div>
      </div>
      {description && !error && <p className="text-xs text-slate-500" data-id="element-1176">{description}</p>}
      {error && <p className="text-xs text-red-600 font-medium" data-id="element-1177">{error}</p>}
    </div>;
}